'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import MaterialCardContent from '@mui/material/CardContent';
import { Divider } from '../Divider';
import { styled } from '@mui/material/styles';
const StyledCardContent = styled(MaterialCardContent)(({ theme }) => ({
    '&:last-child': {
        paddingBottom: theme.spacing(4)
    }
}));
export const CardContent = React.forwardRef(({ divider = 'none', ...props }, ref) => (_jsxs(_Fragment, { children: [(divider === 'top' || divider.includes('top')) && _jsx(Divider, {}), _jsx(StyledCardContent, { ref: ref, ...props }), (divider === 'bottom' || divider.includes('bottom')) && _jsx(Divider, {})] })));
CardContent.displayName = 'CardContent';
